import React from "react"

export const RollenUndRechtemanagement = ({ size = 1 }) => {
  return (
    <svg width={71 * size} height={75 * size} viewBox="0 0 71 75" fill="none">
      <path
        clipRule="evenodd"
        d="M9.168 33h24.737L40 46.587V63H3l6.168-30z"
        stroke="#034B64"
        strokeWidth={3.5}
      />
      <circle cx={21.529} cy={14} r={12} stroke="#034B64" strokeWidth={3.5} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M69 24.16v32.142l-16.513 8.385L36 56.302l.107-32.142s8.848-5 16.87-5 16.023 5 16.023 5z"
        fill="#E5EDF0"
        stroke="#E5EDF0"
        strokeWidth={3}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M62 32.16v32.142l-16.513 8.385L29 64.302l.107-32.142s8.848-5 16.87-5 16.023 5 16.023 5z"
        fill="#FFD62E"
        stroke="#FFD62E"
        strokeWidth={3}
      />
      <path
        d="M37.8 51.067l3.996 3.276 11.405-9.9"
        stroke="#034055"
        strokeWidth={3}
        strokeLinecap="square"
      />
    </svg>
  )
}
